import { render } from "./modal-edit-alternatives.vue?vue&type=template&id=3fde70ae&scoped=true"
import script from "./modal-edit-alternatives.vue?vue&type=script&lang=js"
export * from "./modal-edit-alternatives.vue?vue&type=script&lang=js"

import "./modal-edit-alternatives.vue?vue&type=style&index=0&id=3fde70ae&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fde70ae"],['__file',"src/components/admin-dashboard/modals/modal-edit-alternatives.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3fde70ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3fde70ae', __exports__)) {
    api.reload('3fde70ae', __exports__)
  }
  
  module.hot.accept("./modal-edit-alternatives.vue?vue&type=template&id=3fde70ae&scoped=true", () => {
    api.rerender('3fde70ae', render)
  })

}


export default __exports__